var opt = Object.prototype.toString;
export function isArray(obj) {
    return opt.call(obj) === '[object Array]';
}
export function isObject(obj) {
    return opt.call(obj) === '[object Object]';
}
export function isString(obj) {
    return opt.call(obj) === '[object String]';
}
export function isOneOf(value, validList) {
    return validList.indexOf(value) !== -1;
}
